"use client"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { useMolecule } from "bunshi/react"
/* eslint-disable react-refresh/only-export-components */
import { createContext, useMemo } from "react"
import { BlockchainsMoleculeReatom } from "../blockchains/blockchain-molecule.reatom"
import { WalletConnectMoleculeReatom } from "../wallet-connect/store.reatom"

export const useScanner = (blockchain?: Blockchain) => {
  const { reatomScannerLinkByChainId, reatomScannerLinkByBlockchain } =
    useMolecule(BlockchainsMoleculeReatom)
  const { walletBlockchainNetworkId } = useMolecule(WalletConnectMoleculeReatom)

  // Get scanner link - call factory functions correctly
  const scannerLink = blockchain
    ? reatomScannerLinkByBlockchain()(blockchain)
    : reatomScannerLinkByChainId()(walletBlockchainNetworkId() as number)

  const scanner = useMemo(() => {
    return {
      getTransactionLink(txId: string) {
        return `${scannerLink}/tx/${txId}`
      },
    }
  }, [scannerLink])

  return scanner
}
